import S from './styles.module.scss';
import Typography from '@mui/material/Typography';
import variables from 'styles/variables.scss';
import { CloseOutlined } from '@ant-design/icons';

type CustomModalHeaderProps = {
	title?: string;
	onCancel(): void;
};

const CustomModalHeader = ({ title, onCancel }: CustomModalHeaderProps) => {
	return (
		<div className={S.header}>
			<Typography fontWeight={700} fontSize={16} color={variables.gray_9}>
				{title}
			</Typography>

			<CloseOutlined
				data-testid="closePopupButton"
				onClick={onCancel}
				style={{ fontSize: 15, cursor: 'pointer', color: variables.gray_7 }}
			/>
		</div>
	);
};

export default CustomModalHeader;
